import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DossierPage } from './pages/DossierPage';
import { BiblePage } from './pages/BiblePage';
interface AppProps {
  /** Cupos restantes mostrados en la barra de urgencia. */
  spotsLeft?: number;
  /** Revela los folios narrativos con barras de censura al entrar en pantalla. */
  redactedIntros?: boolean;
}
export function App({
  spotsLeft = 14,
  redactedIntros = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2rikn34nty9b0">
      <Routes data-id="element-1" data-mp="2mm2o6lf6l56l">
        <Route path="/" element={<DossierPage spotsLeft={spotsLeft} redactedIntros={redactedIntros} data-id="element-3" data-mp="2mjpyfm36lqiz" />} data-id="element-2" data-mp="2mmlsv0ftlx2o" />
        <Route path="/bible" element={<BiblePage data-id="element-5" data-mp="2wiferaffj2x4" />} data-id="element-4" data-mp="2wjqi594yq8np" />
      </Routes>
    </BrowserRouter>;
}